module.exports = __webpack_public_path__ + "images/c9f028c18b860374561dcf47fc75d601.svg";